// @ts-nocheck - MUI v7 Grid typing incompatibility
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PrivacyPolicy from './components/PrivacyPolicy';
import TripItinerary from './components/TripItinerary';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
// @ts-ignore - Grid typing issue with MUI v7
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Rating from '@mui/material/Rating';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import ExploreIcon from '@mui/icons-material/Explore';
import MapIcon from '@mui/icons-material/Map';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import FeedbackIcon from '@mui/icons-material/Feedback';
import PeopleIcon from '@mui/icons-material/People';
import Drawer from '@mui/material/Drawer';
import Fab from '@mui/material/Fab';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TripWizard from './components/TripWizard';
import LoginDialog from './components/dialogs/LoginDialog';
import RegisterDialog from './components/dialogs/RegisterDialog';
import ForgotPasswordDialog from './components/dialogs/ForgotPasswordDialog';
import ResetPasswordDialog from './components/dialogs/ResetPasswordDialog';
import FeedbackDialog from './components/dialogs/FeedbackDialog';
import InactivityDialog from './components/dialogs/InactivityDialog';
import * as api from './api';
import { AuthenticationError } from './api';
import { theme, customStyles } from './theme';
import * as analytics from './analytics';

function App() {
  // Check if we're in an OAuth callback popup - detect early to avoid flash
  const isOAuthPopup = Boolean(
    window.opener &&
    (new URLSearchParams(window.location.search).get('code') ||
     new URLSearchParams(window.location.search).get('error'))
  );

  // Large pool of travel images for auto-rotating hero
  const heroImages = [
    'photo-1502602898657-3e91760cbb34', // Paris Eiffel Tower
    'photo-1476514525535-07fb3b4ae5f1', // Lake and mountains
    'photo-1469854523086-cc02fe5d8800', // Mountain landscape
    'photo-1476900543704-4312b78632f8', // Tropical beach
    'photo-1507525428034-b723cf961d3e', // Beach sunset
    'photo-1530789253388-582c481c54b0', // Happy people on beach
    'photo-1488646953014-85cb44e25828', // City skyline
    'photo-1499856871958-5b9627545d1a', // Paris cityscape
    'photo-1519046904884-53103b34b206', // Beach paradise
    'photo-1506905925346-21bda4d32df4', // Mountain peaks
    'photo-1503220317375-aaad61436b1b', // Desert landscape
    'photo-1501594907352-04cda38ebc29', // Machu Picchu
    'photo-1506197603052-3cc9c3a201bd', // Santorini Greece
    'photo-1523906834658-6e24ef2386f9', // Colosseum Rome
    'photo-1513581166391-887a96ddeafd', // Golden Gate Bridge
    'photo-1480714378408-67cf0d13bc1b', // Northern lights
    'photo-1500530855697-b586d89ba3ee', // Dubai cityscape
    'photo-1485738422979-f5c462d49f74', // Bali temple
    'photo-1506929562872-bb421503ef21', // Iceland landscape
    'photo-1504893524553-b855bce32c67', // London skyline
    'photo-1520208422220-d12a3c588e6c', // Tokyo street
    'photo-1517479149777-5f3b1511d5ad', // Amsterdam canals
    'photo-1524492412937-b28074a5d7da', // Taj Mahal
    'photo-1551632811-561732d1e306', // Swiss Alps
    'photo-1528543606781-2f6e6857f318', // Thailand beach
    'photo-1533105079780-92b9be482077', // Great Wall China
    'photo-1512453979798-5ea266f8880c', // Barcelona
    'photo-1509023464722-18d996393ca8', // New York skyline
    'photo-1519677100203-a0e668c92439', // Grand Canyon
    'photo-1543716091-a840c05249ec', // Yosemite
    'photo-1534329539061-64caeb388c42', // Safari wildlife
    'photo-1518509562904-e7ef99cdcc86', // Hot air balloons
    'photo-1506197603052-3cc9c3a201bd', // Greek islands
    'photo-1517639493569-5666a7556742', // Venice canals
    'photo-1467269204594-9661b134dd2b', // Aurora borealis
    'photo-1494233892892-84542a694e72', // Scottish highlands
    'photo-1526772662000-3f88f10405ff', // Rocky mountains
    'photo-1527004013197-933c4bb611b3', // Sydney Opera House
    'photo-1513326738677-b964603b136d', // Petra Jordan
    'photo-1445019980597-93fa8acb246c', // Norwegian fjords
    'photo-1464822759023-fed622ff2c3b', // Alpine peaks
    'photo-1506806732259-39c2d0268443', // Monument Valley
    'photo-1470252649378-9c29740c9fa8', // Maldives overwater
    'photo-1539635278303-d4002c07eae3', // Caribbean beach
    'photo-1504829857797-ddff29c27927', // Asian temple
    'photo-1484820540004-14229fe36ca4', // Hiking trail
    'photo-1500835556837-99ac94a94552', // Mountain lake
    'photo-1506012787146-f92b2d7d6d96', // Desert dunes
    'photo-1519046904884-53103b34b206', // Coastal cliffs
  ];

  // State for auto-rotating hero image
  const [currentHeroImage, setCurrentHeroImage] = useState(() => {
    const randomIndex = Math.floor(Math.random() * heroImages.length);
    return `https://images.unsplash.com/${heroImages[randomIndex]}?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80`;
  });

  // Auto-rotate hero image every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * heroImages.length);
      setCurrentHeroImage(`https://images.unsplash.com/${heroImages[randomIndex]}?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80`);
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, []);

  const [activeSection, setActiveSection] = useState<string>('home');
  const [systemTrips, setSystemTrips] = useState<any[]>([]);
  const [customerTrips, setCustomerTrips] = useState<any[]>([]);
  const [customerTripsLoading, setCustomerTripsLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [carouselIndex, setCarouselIndex] = useState<number>(0);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [, setCustomerId] = useState<number | null>(null); // Used by legacy callback handler
  const [, setLoginLoading] = useState<boolean>(false); // Used by legacy callback handler
  const [customerData, setCustomerData] = useState<any>(null);
  const [customerLoading, setCustomerLoading] = useState<boolean>(false);
  const [callbackProcessed, setCallbackProcessed] = useState<boolean>(false);
  const [isProcessingAuth, setIsProcessingAuth] = useState<boolean>(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState<HTMLElement | null>(null);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState<boolean>(false);
  const [builtTrip, setBuiltTrip] = useState<any>(null);
  const [isSystemTrip, setIsSystemTrip] = useState<boolean>(false);
  const [currentTripView, setCurrentTripView] = useState<string>('wizard'); // 'wizard' or 'itinerary'
  const [tripMenuAnchor, setTripMenuAnchor] = useState<{ [key: string]: HTMLElement | null }>({});
  const [deletingTripId, setDeletingTripId] = useState<number | null>(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState<boolean>(false);
  const [tripToDelete, setTripToDelete] = useState<any>(null);
  const [tripSnackbar, setTripSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'info' }>({ open: false, message: '', severity: 'success' });
  const [selectedCustomerTrip, setSelectedCustomerTrip] = useState<any>(null);
  const [customerTripView, setCustomerTripView] = useState<string>('list'); // 'list' or 'detail'
  const [loginDialogOpen, setLoginDialogOpen] = useState<boolean>(false);
  const [registerDialogOpen, setRegisterDialogOpen] = useState<boolean>(false);
  const [forgotPasswordDialogOpen, setForgotPasswordDialogOpen] = useState<boolean>(false);
  const [resetPasswordDialogOpen, setResetPasswordDialogOpen] = useState<boolean>(false);
  const [resetPasswordToken, setResetPasswordToken] = useState<string>('');
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState<boolean>(false);
  const initialSetupDone = useRef<boolean>(false);
  const authProcessingRef = useRef<boolean>(false);
  const fetchingCustomerTripsRef = useRef<boolean>(false);

  // Responsive breakpoints for carousel
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const carouselCardCount = isMobile ? 1 : isTablet ? 2 : 4;

  const handleAuthCallback = useCallback(async (authParams: string) => {
    try {
      // Prevent duplicate processing
      if (isAuthenticated) {
        setIsProcessingAuth(false);
        authProcessingRef.current = false;
        return;
      }

      setLoginLoading(true);
      const customerId = await api.authenticate(authParams);

      if (customerId > 0) {
        setIsAuthenticated(true);
        setCustomerId(customerId);
        setError(null); // Clear any previous errors
        // Clean up URL - redirect to root
        window.history.replaceState({}, document.title, '/');
      } else {
        setError('Authentication failed. Please try logging in again.');
        setCallbackProcessed(false); // Allow retry
      }
    } catch (err: unknown) {
      console.error('Authentication callback error:', err);
      setError('Authentication failed. Please try logging in again.');
      setCallbackProcessed(false); // Allow retry
    } finally {
      setLoginLoading(false);
      setIsProcessingAuth(false);
      authProcessingRef.current = false;
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!initialSetupDone.current) {
      fetchSystemTrips();
      // checkAuthentication(); // Removed - no auto-authentication on page load
      initialSetupDone.current = true;
    }
    
    // Handle Auth0 login callback - only process once
    if (!callbackProcessed && !isProcessingAuth && !authProcessingRef.current) {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');
      
      if (error) {
        // If running in a popup, notify parent of error and close
        if (window.opener) {
          window.opener.postMessage({ type: 'AUTH_ERROR', error: errorDescription || error }, window.location.origin);
          window.close();
          return;
        }

        setError(`Authentication failed: ${errorDescription || error}`);
        setCallbackProcessed(true);
        // Clean up URL - redirect to root
        window.history.replaceState({}, document.title, '/');
        return;
      }
      
      if (code && !isAuthenticated) {
        // If running in a popup, exchange code for token via backend, then notify parent
        if (window.opener) {
          (async () => {
            try {
              const apiBase = process.env.REACT_APP_API_URL || `${window.location.origin}/api`;
              // Extract provider from the current path e.g. /auth/callback/google
              const provider = window.location.pathname.split('/').pop() || 'google';
              // callback_url must be byte-for-byte identical to what was sent in Step 1
              const callbackUrl = `${window.location.origin}/auth/callback/${provider}`;
              const response = await fetch(`${apiBase}/auth/callback/${provider}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ code, state: state || '', callback_url: callbackUrl }),
              });

              if (!response.ok) {
                throw new Error('Failed to authenticate');
              }

              const data = await response.json();

              // Store token based on rememberMe preference
              const rememberMe = sessionStorage.getItem('auth_remember_me') === 'true';
              sessionStorage.removeItem('auth_remember_me');

              if (rememberMe) {
                localStorage.setItem('auth_token', data.token);
              } else {
                sessionStorage.setItem('auth_token', data.token);
              }

              // Notify parent window of success
              window.opener.postMessage({ type: 'AUTH_CALLBACK' }, window.location.origin);
            } catch (err) {
              window.opener.postMessage(
                { type: 'AUTH_ERROR', error: err instanceof Error ? err.message : 'Authentication failed' },
                window.location.origin
              );
            } finally {
              window.close();
            }
          })();
          return;
        }

        // Fallback for non-popup flow
        setCallbackProcessed(true);
        setIsProcessingAuth(true);
        authProcessingRef.current = true;
        handleAuthCallback(`?code=${code}&state=${state || ''}`);
      }
    }
  }, [callbackProcessed, isAuthenticated, isProcessingAuth, handleAuthCallback]);

  const fetchCustomerData = async () => {
    try {
      setCustomerLoading(true);
      const data = await api.fetchCustomerData();
      setCustomerData(data);
    } catch (error) {
      console.error('Error fetching customer data:', error);

      if (error instanceof AuthenticationError) {
        setError('Please log in to view your profile');
        // Clear authentication state
        setIsAuthenticated(false);
        setCustomerId(null);
        setCustomerData(null);
      } else {
        setError('Failed to load customer profile');
      }
    } finally {
      setCustomerLoading(false);
    }
  };

  const fetchCustomerTrips = useCallback(async () => {
    // Prevent duplicate simultaneous calls
    if (fetchingCustomerTripsRef.current) {
      return;
    }

    try {
      fetchingCustomerTripsRef.current = true;
      setCustomerTripsLoading(true);
      setError(null);
      const data = await api.fetchCustomerTrips();
      setCustomerTrips(data);
    } catch (err: unknown) {
      console.error('Error fetching customer trips:', err);

      if (err instanceof AuthenticationError) {
        setError('Please log in to view your trips');
        // Clear authentication state
        setIsAuthenticated(false);
        setCustomerId(null);
        setCustomerData(null);
        setCustomerTrips([]);
      } else {
        setError(err instanceof Error ? err.message : 'Unknown error');
        setCustomerTrips([]);
      }
    } finally {
      setCustomerTripsLoading(false);
      fetchingCustomerTripsRef.current = false;
    }
  }, []);

  // Fetch customer data when user is authenticated
  useEffect(() => {
    if (isAuthenticated) {
      fetchCustomerData();
    }
  }, [isAuthenticated]);

  // Fetch customer trips when user is authenticated and on my trips page
  useEffect(() => {
    if (isAuthenticated && activeSection === 'mytrips') {
      fetchCustomerTrips();
      // Reset customer trip view when navigating to my trips
      setCustomerTripView('list');
      setSelectedCustomerTrip(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, activeSection]);

  // Check for password reset token in URL (handles /reset-password?token=xxx)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const resetToken = urlParams.get('token');
    const isResetPasswordPath = window.location.pathname === '/reset-password';

    if (resetToken && isResetPasswordPath) {
      setResetPasswordToken(resetToken);
      setResetPasswordDialogOpen(true);
      // Clean up URL
      window.history.replaceState({}, document.title, '/');
    }
  }, []);

  const handleLogin = () => {
    setLoginDialogOpen(true);
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    analytics.trackLogin();
    // Customer data is fetched by useEffect when isAuthenticated changes
  };

  const handleRegisterSuccess = () => {
    setIsAuthenticated(true);
    analytics.trackLogin();
    // Customer data is fetched by useEffect when isAuthenticated changes
  };

  const handleSwitchToRegister = () => {
    setLoginDialogOpen(false);
    setRegisterDialogOpen(true);
  };

  const handleSwitchToLogin = () => {
    setRegisterDialogOpen(false);
    setForgotPasswordDialogOpen(false);
    setLoginDialogOpen(true);
  };

  const handleSwitchToForgotPassword = () => {
    setLoginDialogOpen(false);
    setForgotPasswordDialogOpen(true);
  };

  const handleResetPasswordSuccess = () => {
    setResetPasswordDialogOpen(false);
    setResetPasswordToken('');
    setLoginDialogOpen(true);
  };

  const handleLogout = async () => {
    analytics.trackLogout();

    // Call backend to clear cookie
    await api.logout();

    // Clear local state
    setIsAuthenticated(false);
    setCustomerData(null);
    setCallbackProcessed(false);
    setIsProcessingAuth(false);
    authProcessingRef.current = false;
    setActiveSection('home');
  };



  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const handleProfileClick = () => {
    setActiveSection('profile');
    handleProfileMenuClose();
  };

  const handleTripBuilt = (tripData: any) => {
    setBuiltTrip(tripData);
    setIsSystemTrip(false);
    setCurrentTripView('itinerary');
    window.scrollTo(0, 0);
  };

  const handleStartPlanning = () => {
    // Reset trip wizard state to start fresh
    analytics.trackNavigationClick('start_planning');
    setBuiltTrip(null);
    setCurrentTripView('wizard');
    setActiveSection('wizard');
  };

  const handleLogoutClick = async () => {
    await handleLogout();
    handleProfileMenuClose();
  };

  // Trip menu handlers
  const handleTripMenuOpen = (event: React.MouseEvent<HTMLElement>, tripId: number) => {
    event.stopPropagation();
    setTripMenuAnchor({ ...tripMenuAnchor, [tripId]: event.currentTarget });
  };

  const handleTripMenuClose = (tripId: number) => {
    setTripMenuAnchor({ ...tripMenuAnchor, [tripId]: null });
  };

  const handleDeleteTrip = (trip: any) => {
    handleTripMenuClose(trip.id);
    setTripToDelete(trip);
    setDeleteConfirmOpen(true);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmOpen(false);
    setTripToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (!tripToDelete) return;

    const tripId = tripToDelete.id;
    setDeleteConfirmOpen(false);
    setDeletingTripId(tripId);

    try {
      await api.deleteTripFromCustomer(tripId);
      analytics.trackTripDeleted(tripId);
      setTripSnackbar({ open: true, message: 'Trip deleted successfully', severity: 'success' });
      // Refresh customer trips
      fetchCustomerTrips();
    } catch (err: unknown) {
      console.error('Error deleting trip:', err);

      if (err instanceof AuthenticationError) {
        setTripSnackbar({ open: true, message: 'Please log in to delete trips', severity: 'warning' });
        // Clear authentication state
        setIsAuthenticated(false);
        setCustomerId(null);
        setCustomerData(null);
      } else {
        setTripSnackbar({ open: true, message: 'Failed to delete trip', severity: 'error' });
      }
    } finally {
      setDeletingTripId(null);
      setTripToDelete(null);
    }
  };

  const handleTripSnackbarClose = () => {
    setTripSnackbar({ ...tripSnackbar, open: false });
  };

  const handleCustomerTripClick = (trip: any) => {
    analytics.trackTripViewed(trip.id, trip.title || trip.name);
    setSelectedCustomerTrip(trip);
    setCustomerTripView('detail');
    window.scrollTo(0, 0);
  };

  const handleBackToTripList = () => {
    setCustomerTripView('list');
    setSelectedCustomerTrip(null);
  };

  const handleSystemTripClick = (trip: any) => {
    analytics.trackTripViewed(trip.id, trip.title || trip.name);
    setBuiltTrip(trip);
    setIsSystemTrip(true);
    setCurrentTripView('itinerary');
    setActiveSection('wizard');
    window.scrollTo(0, 0);
  };

  const handleCarouselNext = () => {
    setCarouselIndex((prevIndex) => {
      const maxIndex = Math.max(0, systemTrips.length - carouselCardCount);
      return prevIndex >= maxIndex ? 0 : prevIndex + 1;
    });
  };

  const handleCarouselPrev = () => {
    setCarouselIndex((prevIndex) => {
      const maxIndex = Math.max(0, systemTrips.length - carouselCardCount);
      return prevIndex <= 0 ? maxIndex : prevIndex - 1;
    });
  };

  const fetchSystemTrips = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.fetchSystemTrips();
      setSystemTrips(data);
    } catch (err: unknown) {
      console.error('Error fetching system trips:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      setSystemTrips([]);
    } finally {
      setLoading(false);
    }
  };

  const renderMyTripsPage = () => {
    // Show trip detail view if a trip is selected
    if (customerTripView === 'detail' && selectedCustomerTrip) {
      return (
        <Box>
          <TripItinerary
            tripData={selectedCustomerTrip}
            onBack={handleBackToTripList}
            onReset={handleBackToTripList}
            isAuthenticated={isAuthenticated}
            isSavedTrip={true}
            isSystemTrip={false}
            onTripSaved={() => {
              fetchCustomerTrips();
            }}
            onLoginSuccess={handleLoginSuccess}
          />
        </Box>
      );
    }

    // Show trip list view
    return (
        <Box>
          <Container maxWidth="xl" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom sx={{ mb: 4, textAlign: 'center', fontWeight: 600 }}>
              My Trips
            </Typography>
            
            {customerTripsLoading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : error ? (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            ) : customerTrips.length === 0 ? (
              <Box textAlign="center" py={4}>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  No trips found
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  You haven't created any trips yet. Start planning your first adventure!
                </Typography>
                <Button
                  variant="contained"
                  onClick={handleStartPlanning}
                  sx={{ mt: 2 }}
                  startIcon={<FlightTakeoffIcon />}
                >
                  Plan Your First Trip
                </Button>
              </Box>
            ) : (
              <Grid container spacing={3} sx={{ mx: 0 }}>
                {customerTrips.map((trip: any, index: number) => (
                  // @ts-expect-error MUI v7 Grid typing issue
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={3}
                    lg={3}
                    key={trip.id || index}
                    sx={{
                      display: 'flex',
                      maxWidth: { xs: '100%', sm: '33.333333%', md: '25%', lg: '25%' },
                      flexBasis: { xs: '100%', sm: '33.333333%', md: '25%', lg: '25%' },
                      minWidth: 0,
                    }}
                  >
                    <Card
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        width: '100%',
                        maxWidth: '100%',
                        overflow: 'hidden',
                        position: 'relative',
                      }}>
                      {/* Menu button positioned outside CardActionArea to avoid nested buttons */}
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTripMenuOpen(e, trip.id);
                        }}
                        disabled={deletingTripId === trip.id}
                        sx={{
                          position: 'absolute',
                          top: 8,
                          right: 8,
                          zIndex: 1,
                          bgcolor: 'rgba(255,255,255,0.9)',
                          '&:hover': {
                            bgcolor: 'rgba(255,255,255,1)',
                          }
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <CardActionArea
                        onClick={() => handleCustomerTripClick(trip)}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'stretch',
                          flex: 1,
                          height: '100%',
                          width: '100%',
                          overflow: 'hidden',
                        }}
                      >
                        <Box
                          sx={{
                            position: 'relative',
                            width: '100%',
                            height: 200,
                            overflow: 'hidden',
                            bgcolor: 'grey.200',
                            flexShrink: 0,
                            minWidth: 0,
                          }}
                        >
                          <img
                            src={trip.image_url || "https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"}
                            alt={trip.title || 'Trip'}
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              maxWidth: 'none',
                            }}
                          />
                        </Box>
                        <CardContent sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column', width: '100%', boxSizing: 'border-box' }}>
                          <Typography variant="h6" sx={{ lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mb: 1, pr: 1 }}>
                            {trip.title || trip.name || `Trip ${index + 1}`}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              mb: 2,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              height: '2.8em',
                              lineHeight: 1.4,
                              width: '100%',
                            }}
                          >
                            {trip.description || trip.summary || 'No description available'}
                          </Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 'auto', flexWrap: 'wrap', gap: 1 }}>
                              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                {trip.duration_in_days > 0 && (
                                  <Chip
                                    label={`${trip.duration_in_days} days`}
                                    size="small"
                                    color="primary"
                                  />
                                )}
                                {trip.is_shared && (
                                  <Chip
                                    label={trip.can_edit ? 'Shared' : 'Shared (View Only)'}
                                    size="small"
                                    variant="outlined"
                                    color="secondary"
                                  />
                                )}
                                {trip.shared_with?.length > 0 && (
                                  <Tooltip title={`Shared with ${trip.shared_with.length} ${trip.shared_with.length === 1 ? 'person' : 'people'}`}>
                                    <PeopleIcon sx={{ color: 'grey.500', fontSize: 20 }} />
                                  </Tooltip>
                                )}
                              </Box>
                              {trip.created_at && (
                                <Typography variant="caption" color="text.secondary">
                                  {new Date(trip.created_at).toLocaleDateString()}
                                </Typography>
                              )}
                            </Box>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                    <Menu
                      anchorEl={tripMenuAnchor[trip.id]}
                      open={Boolean(tripMenuAnchor[trip.id])}
                      onClose={() => handleTripMenuClose(trip.id)}
                    >
                      <MenuItem onClick={() => handleDeleteTrip(trip)}>
                        <DeleteIcon sx={{ mr: 1 }} fontSize="small" />
                        Delete Trip
                      </MenuItem>
                    </Menu>
                  </Grid>
                ))}
              </Grid>
            )}
          </Container>
        </Box>
    );
  };

  const renderHomePage = () => {
    return (
      <Box>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
            color: 'text.primary',
            pt: { xs: 3, md: 5 },
            pb: 0,
            mb: 0,
            position: 'relative',
            overflow: 'hidden',
            zIndex: 1
          }}
        >
          {/* Decorative gradient orbs */}
          <Box
            sx={{
              position: 'absolute',
              top: -100,
              right: -100,
              width: 400,
              height: 400,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%)',
              pointerEvents: 'none',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 100,
              left: -150,
              width: 500,
              height: 500,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(30, 58, 138, 0.06) 0%, transparent 70%)',
              pointerEvents: 'none',
            }}
          />

          <Container maxWidth="lg">
            <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
              <Typography
                variant="h1"
                gutterBottom
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
                  lineHeight: 1.2,
                  mb: 2,
                  background: customStyles.gradients.hero,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  letterSpacing: '-0.02em'
                }}
              >
                Discover Your Next Adventure
              </Typography>

<Box display="flex" gap={2} flexWrap="wrap" justifyContent="center" sx={{ mt: 4, mb: { xs: 6, md: 8 } }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleStartPlanning}
                  sx={{
                    background: customStyles.gradients.primary,
                    color: '#ffffff !important',
                    minWidth: 200,
                    px: 4,
                    py: 1.75,
                    fontSize: '1.05rem',
                    fontWeight: 600,
                    borderRadius: '50px',
                    textTransform: 'none',
                    boxShadow: customStyles.shadows.colored.primary,
                    '& .MuiButton-startIcon': {
                      color: '#ffffff',
                    },
                    '&:hover': {
                      background: customStyles.gradients.primary,
                      color: '#ffffff !important',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 12px 32px rgba(30, 58, 138, 0.35)',
                    },
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                  }}
                  startIcon={<FlightTakeoffIcon />}
                >
                  Start Planning
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setActiveSection('trips')}
                  sx={{
                    color: 'primary.main',
                    borderColor: 'primary.main',
                    borderWidth: 2,
                    minWidth: 200,
                    px: 4,
                    py: 1.75,
                    fontSize: '1.05rem',
                    fontWeight: 600,
                    borderRadius: '50px',
                    textTransform: 'none',
                    '&:hover': {
                      borderWidth: 2,
                      borderColor: 'primary.dark',
                      backgroundColor: 'rgba(30, 58, 138, 0.04)',
                      transform: 'translateY(-2px)',
                    },
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                  }}
                  startIcon={<MapIcon />}
                >
                  Browse Trips
                </Button>
              </Box>
            </Box>
          </Container>
          
          <Box sx={{ position: 'relative' }}>
            <Box
              component="img"
              src={currentHeroImage}
              alt="Beautiful travel destination"
              sx={{
                width: '100%',
                height: { xs: 280, sm: 400, md: 500 },
                objectFit: 'cover',
                display: 'block',
                transition: 'all 0.5s ease-in-out',
              }}
            />
            {/* Gradient overlay at bottom of image */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '40%',
                background: 'linear-gradient(to top, rgba(0,0,0,0.3) 0%, transparent 100%)',
                borderRadius: 0,
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Box>

              {/* Featured Destinations Section */}
        <Container maxWidth="lg" sx={{ mt: 6, mb: 8 }}>
        
        {loading && (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            Error loading trips: {error}
          </Alert>
        )}

        {!loading && !error && (
          <Box sx={{ position: 'relative' }}>
            {systemTrips.length === 0 ? (
              <Paper sx={{ p: 6, textAlign: 'center', width: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Discover Amazing Destinations
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  Our AI is working on creating amazing travel experiences for you. Start planning your own adventure!
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleStartPlanning}
                  startIcon={<FlightTakeoffIcon />}
                >
                  Start Planning
                </Button>
              </Paper>
            ) : (
              <>
                {/* Carousel Container - hidden on mobile since Browse Trips provides same view */}
                <Box sx={{
                  display: { xs: 'none', sm: 'flex' },
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 2,
                  pb: 4,
                  mx: 'auto',
                  maxWidth: '1400px'
                }}>
                  {/* Left Navigation Button */}
                  <IconButton
                    onClick={handleCarouselPrev}
                    sx={{
                      flexShrink: 0,
                      bgcolor: 'white',
                      boxShadow: customStyles.shadows.soft.md,
                      '&:hover': {
                        bgcolor: 'white',
                        boxShadow: customStyles.shadows.soft.lg,
                      }
                    }}
                  >
                    <ChevronLeftIcon sx={{ color: 'primary.main', fontSize: 28 }} />
                  </IconButton>

                  {/* Cards Container */}
                  <Box sx={{
                    display: 'flex',
                    gap: { xs: 2, sm: 3 },
                    justifyContent: 'center',
                    flex: 1,
                    px: { xs: 1, sm: 2, md: 6 },
                    py: 2,
                    transition: 'all 0.3s ease-in-out',
                    overflow: 'visible'
                  }}>
                    {systemTrips
                      .slice(carouselIndex, carouselIndex + carouselCardCount)
                      .map((trip, index) => (
                      <Card
                        key={carouselIndex + index}
                        onClick={() => handleSystemTripClick(trip)}
                        sx={{
                          width: { xs: '100%', sm: '300px' },
                          minWidth: { sm: '300px' },
                          display: 'flex',
                          flexDirection: 'column',
                          flexShrink: 0,
                          opacity: 1,
                          cursor: 'pointer',
                          overflow: 'hidden',
                        }}>
                        <CardMedia
                          component="img"
                          height="200"
                          image={trip.image_url || 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'}
                          alt={trip.name || `Trip ${carouselIndex + index + 1}`}
                        />
                        <CardContent sx={{ flexGrow: 1, p: 3 }}>
                          <Typography variant="h6" gutterBottom>
                            {trip.name || `Amazing Trip ${carouselIndex + index + 1}`}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" paragraph>
                            {trip.description || 'Experience the adventure of a lifetime with our carefully crafted itinerary.'}
                          </Typography>
                          <Box display="flex" gap={1} flexWrap="wrap" sx={{ mb: 2 }}>
                            {trip.duration_in_days > 0 ? (
                              <Chip
                                icon={<AccessTimeIcon />}
                                label={`${trip.duration_in_days} days`}
                                size="small"
                                color="primary"
                              />
                            ) : null}
                            {trip.country && (
                              <Chip
                                icon={<LocationOnIcon />}
                                label={trip.country}
                                size="small"
                                variant="outlined"
                              />
                            )}
                            {trip.budget > 0 ? (
                              <Chip
                                icon={<AttachMoneyIcon />}
                                label={`$${trip.budget}`}
                                size="small"
                                color="secondary"
                              />
                            ) : null}
                          </Box>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>

                  {/* Right Navigation Button */}
                  <IconButton
                    onClick={handleCarouselNext}
                    sx={{
                      flexShrink: 0,
                      bgcolor: 'white',
                      boxShadow: customStyles.shadows.soft.md,
                      '&:hover': {
                        bgcolor: 'white',
                        boxShadow: customStyles.shadows.soft.lg,
                      }
                    }}
                  >
                    <ChevronRightIcon sx={{ color: 'primary.main', fontSize: 28 }} />
                  </IconButton>
                </Box>


              </>
            )}
          </Box>
        )}
      </Container>
    </Box>
  );
  };

  // Removed renderTripHeader - using hero image in TripItinerary instead

  const renderSystemTripsPage = () => {
    return (
      <Container maxWidth="lg" sx={{ pt: 4 }}>
      
      {loading && (
        <Box display="flex" justifyContent="center" my={8}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 4 }}>
          Error loading trips: {error}
        </Alert>
      )}

      {!loading && !error && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}>
          {systemTrips.length === 0 ? (
            <Paper sx={{ p: 8, textAlign: 'center', width: '100%' }}>
              <Typography variant="h5" gutterBottom>
                No System Trips Available
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Our AI is currently working on creating amazing travel experiences. Why not create your own custom trip?
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={handleStartPlanning}
                startIcon={<FlightTakeoffIcon />}
              >
                Plan Your Trip
              </Button>
            </Paper>
          ) : (
            systemTrips.map((trip, index) => (
              <Card
                key={index}
                onClick={() => handleSystemTripClick(trip)}
                sx={{
                  width: { xs: '100%', sm: '350px' },
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  overflow: 'hidden',
                }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={trip.image_url || 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'}
                  alt={trip.name || `Trip ${index + 1}`}
                />
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {trip.name || `Amazing Trip ${index + 1}`}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {trip.description || 'Experience the adventure of a lifetime with our carefully crafted itinerary.'}
                  </Typography>
                  <Box display="flex" gap={1} flexWrap="wrap" sx={{ mb: 2 }}>
                    {trip.duration_in_days > 0 ? (
                      <Chip
                        icon={<AccessTimeIcon />}
                        label={`${trip.duration_in_days} days`}
                        size="small"
                        color="primary"
                      />
                    ) : null}
                    {trip.country && (
                      <Chip
                        icon={<LocationOnIcon />}
                        label={trip.country}
                        size="small"
                        variant="outlined"
                      />
                    )}
                    {trip.budget > 0 ? (
                      <Chip
                        icon={<AttachMoneyIcon />}
                        label={`$${trip.budget}`}
                        size="small"
                        color="secondary"
                      />
                    ) : null}
                  </Box>
                </CardContent>
              </Card>
            ))
          )}
        </Box>
      )}
    </Container>
  );
};


  const renderProfilePage = () => (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      {customerLoading && (
        <Box display="flex" justifyContent="center" my={8}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 4 }}>
          {error}
        </Alert>
      )}

      {!customerLoading && !error && customerData && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Profile Header */}
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Avatar
              src={customerData?.picture_url || customerData?.picture || customerData?.profile_image_url || customerData?.avatar_url || customerData?.image_url}
              sx={{
                width: 120,
                height: 120,
                mx: 'auto',
                mb: 2,
                bgcolor: 'primary.main',
                fontSize: '3rem',
                boxShadow: 3,
              }}
            >
              {(customerData.display_name?.[0] || customerData.first_name?.[0] || customerData.name?.[0] || 'U').toUpperCase()}
            </Avatar>
            <Typography variant="h5" fontWeight={600} gutterBottom>
              {customerData.display_name || `${customerData.first_name || ''} ${customerData.last_name || ''}`.trim() || 'User'}
            </Typography>
            {customerData.email && (
              <Typography variant="body2" color="text.secondary">
                {customerData.email}
              </Typography>
            )}
            {customerData.created_at && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                Member since {new Date(customerData.created_at).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
              </Typography>
            )}
          </Box>

          {/* Personal Information */}
          <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
            <Box sx={{ px: 3, py: 2, bgcolor: 'grey.50', borderBottom: '1px solid', borderColor: 'divider' }}>
              <Typography variant="subtitle2" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                Personal Information
              </Typography>
            </Box>
            <Box sx={{ px: 3, py: 2 }}>
              {customerData.first_name && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                  <Typography variant="body2" color="text.secondary">First Name</Typography>
                  <Typography variant="body2" fontWeight={500}>{customerData.first_name}</Typography>
                </Box>
              )}
              {customerData.last_name && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                  <Typography variant="body2" color="text.secondary">Last Name</Typography>
                  <Typography variant="body2" fontWeight={500}>{customerData.last_name}</Typography>
                </Box>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: customerData.phone ? '1px solid' : 'none', borderColor: 'divider' }}>
                <Typography variant="body2" color="text.secondary">Email</Typography>
                <Typography variant="body2" fontWeight={500}>{customerData.email || 'Not provided'}</Typography>
              </Box>
              {customerData.phone && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary">Phone</Typography>
                  <Typography variant="body2" fontWeight={500}>{customerData.phone}</Typography>
                </Box>
              )}
            </Box>
          </Paper>

          {/* Address Information */}
          {(customerData.address || customerData.city || customerData.state || customerData.zip_code) && (
            <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
              <Box sx={{ px: 3, py: 2, bgcolor: 'grey.50', borderBottom: '1px solid', borderColor: 'divider' }}>
                <Typography variant="subtitle2" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Address
                </Typography>
              </Box>
              <Box sx={{ px: 3, py: 2 }}>
                {customerData.address && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="body2" color="text.secondary">Street</Typography>
                    <Typography variant="body2" fontWeight={500}>{customerData.address}</Typography>
                  </Box>
                )}
                {customerData.city && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="body2" color="text.secondary">City</Typography>
                    <Typography variant="body2" fontWeight={500}>{customerData.city}</Typography>
                  </Box>
                )}
                {customerData.state && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: customerData.zip_code ? '1px solid' : 'none', borderColor: 'divider' }}>
                    <Typography variant="body2" color="text.secondary">State</Typography>
                    <Typography variant="body2" fontWeight={500}>{customerData.state}</Typography>
                  </Box>
                )}
                {customerData.zip_code && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5 }}>
                    <Typography variant="body2" color="text.secondary">ZIP Code</Typography>
                    <Typography variant="body2" fontWeight={500}>{customerData.zip_code}</Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          )}

                  </Box>
      )}

      {!customerLoading && !error && !customerData && (
        <Paper variant="outlined" sx={{ p: 6, textAlign: 'center', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            No Profile Data Available
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Unable to load your profile information. Please try refreshing the page.
          </Typography>
          <Button
            variant="contained"
            onClick={fetchCustomerData}
            startIcon={<PersonIcon />}
          >
            Refresh Profile
          </Button>
        </Paper>
      )}
    </Container>
  );

  // Render the privacy policy page inline (no redirect) so it shares the app's theme
  if (window.location.pathname === '/privacy') {
    return <PrivacyPolicy />;
  }

  // If we're in an OAuth popup, show a loading state instead of the full app
  if (isOAuthPopup) {
    return (
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            bgcolor: 'background.default',
          }}
        >
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="body1" color="text.secondary">
            Completing sign in...
          </Typography>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ flexGrow: 1 }}>
        {/* Navigation */}
        <AppBar position="sticky" elevation={0} sx={{
          background: customStyles.glass.background,
          backdropFilter: customStyles.glass.backdropFilter,
          WebkitBackdropFilter: customStyles.glass.backdropFilter,
          borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
          color: 'text.primary',
          zIndex: 1100
        }}>
          <Toolbar>
            {/* Mobile Menu Icon */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setMobileDrawerOpen(true)}
              sx={{ mr: 1, display: { xs: 'flex', md: 'none' } }}
            >
              <MenuIcon />
            </IconButton>

            <Box
              sx={{
                flexGrow: 1,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                '&:hover': {
                  opacity: 0.8
                }
              }}
              onClick={() => {
                setActiveSection('home');
                setMobileDrawerOpen(false);
              }}
            >
              <img
                src="https://storage.googleapis.com/orion-trips-staging/images/logo/logo6.png"
                alt="Orion Adventures"
                style={{
                  height: 55,
                  width: 'auto',
                  objectFit: 'contain'
                }}
              />
            </Box>
            {isAuthenticated ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {customerData && (
                  <Typography
                    variant="body1"
                    sx={{
                      display: { xs: 'none', sm: 'block' },
                      color: 'text.primary',
                      fontSize: '0.95rem',
                      mr: 1
                    }}
                  >
                    Welcome, {customerData.display_name || customerData.first_name || customerData.name || 'User'}
                  </Typography>
                )}
                <IconButton
                  onClick={handleProfileMenuOpen}
                  sx={{
                    p: 0,
                    '&:hover': {
                      opacity: 0.8
                    }
                  }}
                >
                  <Avatar
                    src={customerData?.picture_url || customerData?.picture || customerData?.profile_image_url || customerData?.avatar_url || customerData?.image_url}
                    sx={{
                      width: 40,
                      height: 40,
                      bgcolor: 'primary.main',
                      fontSize: '1.2rem',
                      border: '2px solid white',
                      boxShadow: 1
                    }}
                  >
                    {(customerData?.display_name?.[0] || customerData?.first_name?.[0] || customerData?.name?.[0] || 'U').toUpperCase()}
                  </Avatar>
                </IconButton>
                
                <Menu
                  anchorEl={profileMenuAnchor}
                  open={Boolean(profileMenuAnchor)}
                  onClose={handleProfileMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 180,
                      boxShadow: 3,
                      '& .MuiMenuItem-root': {
                        py: 1.5,
                        px: 2,
                      }
                    }
                  }}
                >
                  <MenuItem onClick={handleProfileClick}>
                    <PersonIcon sx={{ mr: 2, fontSize: 20, color: 'text.primary' }} />
                    Profile
                  </MenuItem>
                  <MenuItem onClick={() => {
                    setActiveSection('mytrips');
                    setCustomerTripView('list');
                    setSelectedCustomerTrip(null);
                    fetchCustomerTrips();
                    handleProfileMenuClose();
                  }}>
                    <FlightTakeoffIcon sx={{ mr: 2, fontSize: 20, color: 'text.primary' }} />
                    My Trips
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleLogoutClick}>
                    <LogoutIcon sx={{ mr: 2, fontSize: 20, color: 'text.primary' }} />
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            ) : (
              <Link
                component="button"
                onClick={handleLogin}
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '1rem',
                  '&:hover': {
                    textDecoration: 'underline',
                    color: 'primary.dark'
                  }
                }}
              >
                Login
              </Link>
            )}
          </Toolbar>
        </AppBar>

        {/* Mobile Navigation Drawer */}
        <Drawer
          anchor="left"
          open={mobileDrawerOpen}
          onClose={() => setMobileDrawerOpen(false)}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              width: 300,
              boxSizing: 'border-box',
              borderRadius: '0 20px 20px 0',
              boxShadow: customStyles.shadows.soft.xl,
            },
          }}
        >
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography variant="h6" color="primary.main" fontWeight="bold">
              Menu
            </Typography>
            <IconButton onClick={() => setMobileDrawerOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { setActiveSection('home'); setMobileDrawerOpen(false); }}>
                <ListItemIcon><HomeIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Home" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { setActiveSection('trips'); setMobileDrawerOpen(false); }}>
                <ListItemIcon><MapIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Browse Trips" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { setFeedbackDialogOpen(true); setMobileDrawerOpen(false); }}>
                <ListItemIcon><FeedbackIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Feedback" />
              </ListItemButton>
            </ListItem>
            {isAuthenticated && (
              <>
                <Divider sx={{ my: 1 }} />
                <ListItem disablePadding>
                  <ListItemButton onClick={() => { setActiveSection('profile'); setMobileDrawerOpen(false); }}>
                    <ListItemIcon><PersonIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Profile" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => { setActiveSection('mytrips'); setCustomerTripView('list'); setSelectedCustomerTrip(null); fetchCustomerTrips(); setMobileDrawerOpen(false); }}>
                    <ListItemIcon><FlightTakeoffIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="My Trips" />
                  </ListItemButton>
                </ListItem>
                <Divider sx={{ my: 1 }} />
                <ListItem disablePadding>
                  <ListItemButton onClick={() => { handleLogoutClick(); setMobileDrawerOpen(false); }}>
                    <ListItemIcon><LogoutIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {!isAuthenticated && (
              <>
                <Divider sx={{ my: 1 }} />
                <ListItem disablePadding>
                  <ListItemButton onClick={() => { handleLogin(); setMobileDrawerOpen(false); }}>
                    <ListItemIcon><PersonIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Login" />
                  </ListItemButton>
                </ListItem>
              </>
            )}
          </List>
        </Drawer>

        {/* Main Content */}
        <Box sx={{ minHeight: '100vh' }}>
          {activeSection === 'home' && renderHomePage()}
          {activeSection === 'trips' && renderSystemTripsPage()}
          {activeSection === 'mytrips' && renderMyTripsPage()}
          {activeSection === 'wizard' && (
            <>
              {currentTripView === 'wizard' && <TripWizard onTripBuilt={handleTripBuilt} />}
              {currentTripView === 'itinerary' && builtTrip && (
                <TripItinerary
                  tripData={builtTrip}
                  onBack={() => {
                    if (isSystemTrip) {
                      setBuiltTrip(null);
                      setIsSystemTrip(false);
                      setActiveSection('trips');
                    } else {
                      setCurrentTripView('wizard');
                    }
                  }}
                  onReset={() => {
                    setBuiltTrip(null);
                    setIsSystemTrip(false);
                    setCurrentTripView('wizard');
                  }}
                  isAuthenticated={isAuthenticated}
                  isSavedTrip={false}
                  isSystemTrip={isSystemTrip}
                  onTripSaved={() => {
                    // Refresh customer trips after saving
                    if (isAuthenticated) {
                      fetchCustomerTrips();
                    }
                  }}
                  onLoginSuccess={handleLoginSuccess}
                />
              )}
            </>
          )}
          {activeSection === 'profile' && renderProfilePage()}
        </Box>
      </Box>

      {/* Floating Feedback Button - hidden on mobile (uses drawer instead) */}
      <Fab
        color="primary"
        aria-label="feedback"
        onClick={() => setFeedbackDialogOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'none', md: 'flex' },
          zIndex: 1000,
        }}
      >
        <FeedbackIcon />
      </Fab>

      {/* Delete Confirmation Dialog - OPTION 1: Red Banner Style */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        {/* Soft red gradient header banner */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #ef5350 0%, #e57373 100%)',
            color: 'white',
            p: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Box
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.25)',
              borderRadius: '50%',
              width: 48,
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <WarningAmberIcon sx={{ fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
              Delete Trip
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.95 }}>
              This action cannot be undone
            </Typography>
          </Box>
        </Box>

        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to permanently delete this trip?
          </Typography>
          <Box
            sx={{
              bgcolor: 'rgba(239, 83, 80, 0.06)',
              border: '1px solid rgba(239, 83, 80, 0.15)',
              borderRadius: 2,
              p: 2,
              mt: 2
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
              {tripToDelete?.title || tripToDelete?.name || 'Untitled Trip'}
            </Typography>
            {tripToDelete?.duration_in_days && (
              <Typography variant="caption" color="text.secondary">
                {tripToDelete.duration_in_days} days • Created {tripToDelete.created_at ? new Date(tripToDelete.created_at).toLocaleDateString() : 'recently'}
              </Typography>
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0, gap: 1 }}>
          <Button
            onClick={handleCancelDelete}
            disabled={deletingTripId !== null}
            variant="outlined"
            sx={{ px: 3 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            disabled={deletingTripId !== null}
            startIcon={deletingTripId !== null ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
            sx={{
              px: 3,
              bgcolor: '#ef5350',
              '&:hover': {
                bgcolor: '#e53935'
              }
            }}
          >
            {deletingTripId !== null ? 'Deleting...' : 'Delete Trip'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Login Dialog */}
      <LoginDialog
        open={loginDialogOpen}
        onClose={() => setLoginDialogOpen(false)}
        onSuccess={handleLoginSuccess}
        onRegisterClick={handleSwitchToRegister}
        onForgotPasswordClick={handleSwitchToForgotPassword}
      />

      {/* Register Dialog */}
      <RegisterDialog
        open={registerDialogOpen}
        onClose={() => setRegisterDialogOpen(false)}
        onSuccess={handleRegisterSuccess}
        onLoginClick={handleSwitchToLogin}
      />

      {/* Forgot Password Dialog */}
      <ForgotPasswordDialog
        open={forgotPasswordDialogOpen}
        onClose={() => setForgotPasswordDialogOpen(false)}
        onBackToLogin={handleSwitchToLogin}
      />

      {/* Reset Password Dialog */}
      <ResetPasswordDialog
        open={resetPasswordDialogOpen}
        token={resetPasswordToken}
        onClose={() => {
          setResetPasswordDialogOpen(false);
          setResetPasswordToken('');
        }}
        onSuccess={handleResetPasswordSuccess}
      />

      {/* Feedback Dialog */}
      <FeedbackDialog
        open={feedbackDialogOpen}
        onClose={() => setFeedbackDialogOpen(false)}
      />

      {/* Inactivity Timeout Dialog */}
      <InactivityDialog
        isAuthenticated={isAuthenticated}
        onLogout={handleLogout}
      />

      {/* Snackbar for trip actions */}
      <Snackbar
        open={tripSnackbar.open}
        autoHideDuration={6000}
        onClose={handleTripSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleTripSnackbarClose} severity={tripSnackbar.severity} sx={{ width: '100%' }}>
          {tripSnackbar.message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}

export default App;
